export enum OtpVerifyMethod {
  Email = 'email',
  SMS = 'sms',
  Unknown = 'unknown',
}
